import { AlertOctagon, AlertTriangle, Info, CheckCircle } from 'lucide-react';
import type { AlertSeverity, AlertStatus } from '../api';

const SEVERITY_CFG: Record<AlertSeverity, { label: string; className: string; Icon: typeof AlertOctagon }> = {
  critical: { label: 'Crítico', className: 'bg-red-100 text-red-800 border-red-200', Icon: AlertOctagon },
  warning: { label: 'Atenção', className: 'bg-yellow-100 text-yellow-800 border-yellow-200', Icon: AlertTriangle },
  info: { label: 'Informativo', className: 'bg-blue-100 text-blue-800 border-blue-200', Icon: Info },
};

const STATUS_LABELS: Record<AlertStatus, string> = {
  open: 'Aberto',
  acknowledged: 'Reconhecido',
  resolved: 'Resolvido',
};

interface Props {
  severity: AlertSeverity;
  status?: AlertStatus;
  showLabel?: boolean;
}

export function AlertBadge({ severity, status, showLabel = true }: Props) {
  const cfg = SEVERITY_CFG[severity];
  const Icon = status === 'resolved' ? CheckCircle : cfg.Icon;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium ${
        status === 'resolved' ? 'bg-green-100 text-green-800 border-green-200' : cfg.className
      }`}
    >
      <Icon className="h-3 w-3" />
      {showLabel && (status ? STATUS_LABELS[status] : cfg.label)}
    </span>
  );
}

export const SEVERITY_LABELS = Object.fromEntries(
  (Object.entries(SEVERITY_CFG) as Array<[AlertSeverity, { label: string }]>).map(([k, v]) => [k, v.label]),
) as Record<AlertSeverity, string>;

export const ALERT_STATUS_LABELS = STATUS_LABELS;

export const ALERT_TYPE_LABELS: Record<string, string> = {
  warranty_expiring: 'Garantia próxima do vencimento',
  warranty_expired: 'Garantia vencida',
  license_expiring: 'Licença próxima do vencimento',
  license_expired: 'Licença vencida',
  license_limit_reached: 'Limite de licenças atingido',
  custodian_inactive: 'Responsável inativo',
  asset_not_found: 'Ativo não localizado',
  inventory_pending: 'Inventário pendente',
  loan_overdue: 'Empréstimo vencido',
  stock_minimum_reached: 'Estoque abaixo do mínimo',
  asset_damaged: 'Ativo danificado',
};
